import 'ng-file-upload';
import _ from 'lodash';
import {
  getMimeType,
  isExtensionValid,
  getFileMetaData,
} from '../../../utils/fileCheck';

import template from './doctor-file-transfer.html';
import { RootScopeEvents } from 'common/services/root-scope-types';

export default angular
  .module('doxy.common.components.file-transfer.doctor-file-transfer', [
    'ngFileUpload',
  ])
  .component('fileDoctorTransfer', {
    template: template,
    bindings: {
      state: '<',
      target: '<',
      innerMediator: '<',
    },
    controller: function (
      notificationFactory,
      Upload,
      apiUrl,
      LoopBackAuth,
      User,
      roomHelpersFactory,
      VideoProviderFactory,
      $rootScope
    ) {
      const mb = 1000000;
      const limitMb = 100;
      this.upload = (files) => {
        const file = files && files[0];
        if (!file) return;
        if (file.size > limitMb * mb) {
          notificationFactory.showCommon(
            'info',
            'file-transfer.fileLimit{{limitMb}}',
            null,
            5000,
            {
              limitMb,
            }
          );
          return;
        }

        const fileMetaData = getFileMetaData(file);

        if (isExtensionValid(file.name) === false) {
          notificationFactory.showCommon(
            'info',
            'file-transfer.file-not-supported'
          );
          return;
        }

        this.state.notificationsStatus = 'UPLOADING';

        this.file = file.name;
        Upload.upload({
          url: apiUrl + '/api/privateStorages/uploadFile',
          headers: { authorization: LoopBackAuth.accessTokenId },
          file: file,
          params: {
            temporary: true,
          },
        })
          .then(({ data }) => {
            $rootScope.$emit(RootScopeEvents.FILE_TRANSFER.FINISHED, {
              room_id: _.get(roomHelpersFactory.getRoom(), 'id'),
              session_id: _.get(
                VideoProviderFactory,
                'activeProvider.callSession.id',
                null
              ),
              extension: fileMetaData.extension,
              mime: file.type,
            });
            this.innerMediator.emit('doctorUpload', {
              url: data.url,
              name: file.name,
              size: file.size,
            });
          })
          .catch((e) => {
            this.innerMediator.emit('doctorUploadError', e);
          });
      };

      this.requestFile = () => {
        //only for doctor
        User.createCurrentPatientToken().$promise.then((token) => {
          this.innerMediator.emit('requestFile', { token: token.id });
        });
      };

      this.accept = () => {
        this.innerMediator.emit('accept');
      };

      this.close = () => {
        this.innerMediator.emit('cancel');
      };
    },
  }).name;
